export enum QuestionnaireRoutes {
  root = 'questionnaire',
}
